export default __webpack_public_path__ + "static/media/Specialised Application.6146d74d.jpg";